<template>
  <div class="design-container main-content">
    <custom-headers :title="headerTitle" />
    <div
      class="backpage-container"
      @mouseenter="triggerBackpageAnimate()"
      @mouseleave="offBackpageAnimate()"
      @click="backpage"
    >
      <lottie
        :options="backpageDefaultOptions"
        @animCreated="anim => backpageHandleAnimation(anim)"
      />
    </div>
    <a-row type="flex">
      <a-col :span="24" class="line-stickers-header">
        <a-row>
          <a-col :span="12" class="clearfix d-flex">
            <div
              class="line-stickers-demo-img"
              :class="{ active: lineStickers[lineStickerActiveIndex].isActive }"
            >
              <img :src="lineStickers[lineStickerActiveIndex].imgSrc" />
            </div>
            <div class="line-stickers-header-article">
              <a
                class="line-stickers-store"
                :href="lineStickers[lineStickerActiveIndex].lineStore.link"
                target="_blank"
              >
                <span>LINE</span><span>STORE</span>
              </a>
              <span class="line-stickers-title">{{
                lineStickers[lineStickerActiveIndex].lineStore.name
              }}</span>
            </div>
          </a-col>
          <a-col :span="12" class="line-stickers-thumbnail-list">
            <ul>
              <li
                :class="{
                  active: lineStickerItem.isActive,
                  disabled: lineStickerIsDisabled
                }"
                v-for="(lineStickerItem, lineStickerIndex) in lineStickers"
                :key="'line-stickers-' + lineStickerIndex"
                @click="
                  lineStickerActiveHandle(lineStickerItem, lineStickerIndex)
                "
              >
                <img :src="lineStickerItem.imgSrc" />
              </li>
            </ul>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" class="line-stickers-content">
        <ParticleEffectButton
          :visible.sync="btnOps.visible"
          :options="btnOps"
          ref="pcb"
          cls="btn-cls"
        >
          <div class="particle-mask">
            <div class="line-stickers-description">
              <img :src="lineStickers[lineStickerActiveIndex].completeImgSrc" />
            </div>
          </div>
        </ParticleEffectButton>
      </a-col>
    </a-row>
    <ul class="line-stickers-container"></ul>
  </div>
</template>
<script>
import ParticleEffectButton from "vue-particle-effect-buttons";
import Lottie from "vue-lottie";
import * as backArrowJSON from "../assets/json/back-arrow.json";
import CustomHeaders from "../components/Header.vue";
import lineStickers1 from "../assets/img/line-stickers1.svg";
import lineStickers2 from "../assets/img/line-stickers2.svg";
import lineStickers3 from "../assets/img/line-stickers3.svg";
import completeImgSrc1 from "../assets/img/stickers-portfolio1.png";
import completeImgSrc2 from "../assets/img/stickers-portfolio2.png";
import completeImgSrc3 from "../assets/img/stickers-portfolio3.png";

export default {
  name: "Design",
  components: {
    "custom-headers": CustomHeaders,
    lottie: Lottie,
    ParticleEffectButton
  },
  data() {
    return {
      headerTitle: "Design",
      backpageDefaultOptions: { animationData: backArrowJSON.default },
      lineStickers: [
        {
          isActive: true,
          imgSrc: lineStickers1,
          completeImgSrc: completeImgSrc1,
          lineStore: {
            name: "帕可雀與嘟嘟蠶-1",
            link:
              "https://store.line.me/stickershop/product/11687823/zh-Hant?from=sticker"
          }
        },
        {
          isActive: false,
          imgSrc: lineStickers2,
          completeImgSrc: completeImgSrc2,
          lineStore: {
            name: "帕可雀與嘟嘟蠶-2",
            link:
              "https://store.line.me/stickershop/product/11712712/zh-Hant?from=sticker"
          }
        },
        {
          isActive: false,
          imgSrc: lineStickers3,
          completeImgSrc: completeImgSrc3,
          lineStore: {
            name: "帕可雀與嘟嘟蠶-3",
            link:
              "https://store.line.me/stickershop/product/11701102/zh-Hant?from=sticker"
          }
        }
      ],
      lineStickerActiveIndex: 0,
      lineStickerTimer: 0,
      lineStickerIsDisabled: false,
      cssStyle: {},
      btnOps: {
        onComplete: () => {
          if (!this.btnOps.visible) {
            this.btnOps.visible = !this.btnOps.visible;
          }
          this.lineStickerIsDisabled = false;
        },
        visible: true,
        size: 8,
        particlesAmountCoefficient: 6,
        oscillationCoefficient: 100,
        type: "triangle",
        direction: "top",
        duration: 250,
        easing: "easeInExpo"
      }
    };
  },
  methods: {
    backpageHandleAnimation(anim) {
      this.backpageAnim = anim;
      this.backpageAnim.stop();
    },
    triggerBackpageAnimate() {
      this.backpageAnim.play();
    },
    offBackpageAnimate() {
      this.backpageAnim.stop();
    },
    backpage() {
      this.$router.push("/");
    },
    lineStickerActiveHandle(lineStickerItem, lineStickerIndex) {
      this.lineStickerIsDisabled = true;
      this.lineStickers.forEach(item => {
        item.isActive = false;
      });
      this.btnOps.visible = !this.btnOps.visible;
      clearTimeout(this.lineStickerTimer);
      //延遲做出demo大縮圖的漸變
      this.lineStickerTimer = setTimeout(() => {
        lineStickerItem.isActive = true;
        this.lineStickerActiveIndex = lineStickerIndex;
      }, 500);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../css/variable.scss";

.main-content {
  .line-stickers-header {
    border-bottom: 1px solid $border-color;

    .line-stickers-demo-img {
      float: left;
      margin-right: 20px;
      transition: all 0.5s;
      opacity: 0;

      &.active {
        opacity: 1;
      }
      > img {
        width: 200px;
      }
    }
    .line-stickers-header-article {
      float: left;
      align-self: flex-end;
      margin-bottom: 20px;

      .line-stickers-store {
        background-color: #313131;
        padding: 5px 10px;
        font-size: 1.3rem;
        display: inline-block;
        margin-bottom: 5px;

        > span:first-of-type {
          color: #fff;
        }
        > span:nth-of-type(2) {
          color: #00b800;
          margin-left: 10px;
        }
      }
      .line-stickers-title {
        padding: 10px;
        border-radius: 5px;
        background-color: #00b4eb;
        color: #fff;
        font-size: 1.2rem;
        display: block;
      }
    }
    .line-stickers-thumbnail-list {
      position: absolute;
      right: 0;
      bottom: 0;

      ul {
        text-align: right;

        li {
          display: inline-block;
          border-radius: 50%;
          background-color: #a5a5a5;
          padding: 12px;
          margin-left: 10px;
          transition: all 0.5s;
          cursor: pointer;
          position: relative;

          &.active {
            background-color: #f1f473;

            &:before {
              content: "";
              display: inline-block;
              transform: rotate(45deg);
              height: 31px;
              position: absolute;
              right: 0;
              top: -15px;
              width: 20px;
              border-bottom: 7px solid #ea3535;
              border-right: 7px solid #ea3535;
            }
          }
          &.disabled {
            pointer-events: none;
          }
          &:hover {
            background-color: #f1f473;
          }

          > img {
            width: 55px;
          }
        }
      }
    }
  }
  .line-stickers-content {
    text-align: center;
    overflow: hidden;

    .line-stickers-description {
      padding: 2vw;
      border-radius: 5px;

      > img {
        width: 100%;
        max-width: 768px;
      }
    }
  }
}
@media only screen and (max-width: 1280px) {
  .main-content {
    .line-stickers-header {
      .line-stickers-demo-img {
        > img {
          width: 150px;
        }
      }
      .line-stickers-header-article {
        .line-stickers-store {
          font-size: 1rem;
        }
        .line-stickers-title {
          font-size: 1rem;
        }
      }
    }
  }
}
@media only screen and (max-width: 1280px) and (max-height: 768px) {
  .main-content {
    .line-stickers-header {
      margin-top: 15px;

      .line-stickers-demo-img {
        > img {
          width: 150px;
        }
      }
      .line-stickers-header-article {
        .line-stickers-store {
          font-size: 1rem;
        }
        .line-stickers-title {
          font-size: 1rem;
        }
      }
    }
    .line-stickers-content {
      text-align: center;
      overflow: hidden;

      .line-stickers-description {
        padding: 1vw;

        > img {
          max-height: 55vh;
          width: auto;
          max-width: none;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.particles-button {
  background-color: #5f5f5f !important;
  pointer-events: none;

  .particle-mask {
    background-color: #fff;
    margin: -1.5rem -3rem;
  }
}
</style>
